import { Component, Inject, Input, OnInit } from '@angular/core';
import { JardinModel } from 'src/app/model/Jardin.model';
import { AdministracionComponent } from '../../administracion.component';

@Component({
  selector: 'app-simulacion-jardin-administrador',
  templateUrl: './simulacion-jardin-administrador.component.html',
  styleUrls: ['./simulacion-jardin-administrador.component.css']
})
export class SimulacionJardinAdministradorComponent implements OnInit {

  @Input()jardin: JardinModel;
  
  constructor(
    @Inject(AdministracionComponent) private parent: AdministracionComponent
  ) { }

  ngOnInit(): void {
  }

  volver(){
    this.parent.ngOnInit();
  }
  
}
